import getStore from "../store/store";
import { getCdnUrl } from "owa-config";
import { isGlobalFeatureEnabled } from "owa-feature-flags";

const FAVICON_RELATIVE_PATH = "images/favicons";
const MAIL_SEEN_FAVICON = `${FAVICON_RELATIVE_PATH}/mail-seen.ico`;
const MAIL_UNSEEN_FAVICON = `${FAVICON_RELATIVE_PATH}/mail-unseen.ico`;

let OLK_ICON: string | undefined;
let OLK_MAIL_UNSEEN_OVERLAY_ICON: string | undefined;

export function mailFaviconProvider(): string {
    var mailSeenIcon: string = MAIL_SEEN_FAVICON;
    var mailUnseenIcon: string = MAIL_UNSEEN_FAVICON;
    
    if (isGlobalFeatureEnabled("mail-updateHostAppIcon")) {
        if (!OLK_ICON) {
            OLK_ICON = getNativeHostIconUrl("Outlook.ico");
        }
        
        mailSeenIcon = OLK_ICON;
        mailUnseenIcon = OLK_ICON;
    }
    
    return !getStore().areMessagesUnseen ? mailSeenIcon : mailUnseenIcon;
}

export function mailOverlayIconProvider(): string | undefined {
    if (isGlobalFeatureEnabled("mail-updateHostAppIcon")) {
        if (!OLK_MAIL_UNSEEN_OVERLAY_ICON) {
            OLK_MAIL_UNSEEN_OVERLAY_ICON = getNativeHostIconUrl("outlook-badge-newmail-win11.ico");
        }
        
        return !getStore().areMessagesUnseen
            ? "" // Explicitly indicates no overlay
            : OLK_MAIL_UNSEEN_OVERLAY_ICON;
    }
    
    return undefined;
}

function getNativeHostIconUrl(imageRelativePath: string): string {
    return `https:${getCdnUrl()}assets/native-host/v2/${imageRelativePath}`;
}
